'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp2;

var _Link = require('components/Link/Link');

var _Link2 = _interopRequireDefault(_Link);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _Footer = require('./Footer.scss');

var _Footer2 = _interopRequireDefault(_Footer);

var _Footer3 = require('components/Pachantiew/Footer');

var _Footer4 = _interopRequireDefault(_Footer3);

var _ZHFooter = require('components/Footer/ZHFooter');

var _ZHFooter2 = _interopRequireDefault(_ZHFooter);

var _FooterBlock = require('components/Footer/FooterBlock');

var _FooterBlock2 = _interopRequireDefault(_FooterBlock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  Footer: {
    displayName: 'Footer'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/containers/Footer/Footer.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

var pickAndRenderFooter = function pickAndRenderFooter(props) {
  return {
    en: _react3.default.createElement(
      'footer',
      { styleName: 'footer' },
      _react3.default.createElement(
        'div',
        { styleName: 'footer-container' },
        _react3.default.createElement(
          'div',
          { styleName: 'row-footer' },
          _react3.default.createElement(_FooterBlock2.default, null),
          _react3.default.createElement(
            'div',
            { styleName: 'col-footer-list' },
            _react3.default.createElement(
              'h4',
              { styleName: 'footer-title' },
              'Travelers'
            ),
            _react3.default.createElement(
              'ul',
              { styleName: 'footer-list' },
              _react3.default.createElement(
                'li',
                null,
                _react3.default.createElement(
                  'a',
                  { target: '_blank', href: 'https://www.takemetour.com/help-center/traveler', rel: 'noopener noreferrer' },
                  'For Travelers'
                )
              ),
              _react3.default.createElement(
                'li',
                null,
                _react3.default.createElement(
                  'a',
                  { href: '/get-started' },
                  'Get Started'
                )
              ),
              _react3.default.createElement(
                'li',
                null,
                _react3.default.createElement(
                  'a',
                  { href: '/trust-and-safety' },
                  'Trust & Safety'
                )
              ),
              _react3.default.createElement(
                'li',
                null,
                _react3.default.createElement(
                  'a',
                  { target: '_blank', href: 'https://www.takemetour.com/help-center/traveler?topic=Change%20and%20Cancellation%20policy&subtitle=Trip', rel: 'noopener noreferrer' },
                  'Cancellation Policy'
                )
              ),
              _react3.default.createElement(
                'li',
                null,
                _react3.default.createElement(
                  _Link2.default,
                  { target: '_blank', to: '/article' },
                  'Articles'
                )
              )
            )
          ),
          _react3.default.createElement(
            'div',
            { styleName: 'col-footer-list' },
            _react3.default.createElement(
              'h4',
              { styleName: 'footer-title' },
              'Local Experts'
            ),
            _react3.default.createElement(
              'ul',
              { styleName: 'footer-list' },
              _react3.default.createElement(
                'li',
                null,
                _react3.default.createElement(
                  'a',
                  { target: '_blank', href: 'https://www.takemetour.com/help-center/local-expert', rel: 'noopener noreferrer' },
                  'For Local Experts'
                )
              ),
              _react3.default.createElement(
                'li',
                null,
                _react3.default.createElement(
                  'a',
                  { href: '/local-expert-benefits' },
                  'Local Expert Benefits'
                )
              ),
              _react3.default.createElement(
                'li',
                null,
                _react3.default.createElement(
                  _Link2.default,
                  { to: props.user && props.user.is_local_expert ? '/dashboard/listing' : '/local-expert-benefits' },
                  'List Your Trip'
                )
              )
            )
          ),
          _react3.default.createElement(
            'div',
            { styleName: 'col-footer-list' },
            _react3.default.createElement(
              'h4',
              { styleName: 'footer-title' },
              'General'
            ),
            _react3.default.createElement(
              'ul',
              { styleName: 'footer-list' },
              _react3.default.createElement(
                'li',
                null,
                _react3.default.createElement(
                  'a',
                  { href: '/about-us' },
                  'About Us'
                )
              ),
              _react3.default.createElement(
                'li',
                null,
                _react3.default.createElement(
                  'a',
                  { target: '_blank', href: 'http://blog.takemetour.com/', rel: 'noopener noreferrer' },
                  'Blog'
                )
              ),
              _react3.default.createElement(
                'li',
                null,
                _react3.default.createElement(
                  _Link2.default,
                  { to: '/career' },
                  'Careers'
                )
              ),
              _react3.default.createElement(
                'li',
                null,
                _react3.default.createElement(
                  'a',
                  { target: '_blank', href: 'https://www.takemetour.com/article/terms-conditions-and-disclaimer', rel: 'noopener noreferrer' },
                  'T&Cs'
                )
              ),
              _react3.default.createElement(
                'li',
                null,
                _react3.default.createElement(
                  'a',
                  { target: '_blank', href: 'https://www.takemetour.com/article/privacy-policy', rel: 'noopener noreferrer' },
                  'Privacy Policy'
                )
              ),
              _react3.default.createElement(
                'li',
                null,
                _react3.default.createElement(
                  'a',
                  { target: '_blank', href: 'https://www.takemetour.com/help-center', rel: 'noopener noreferrer' },
                  'Help Center'
                )
              ),
              _react3.default.createElement(
                'li',
                null,
                _react3.default.createElement(
                  _Link2.default,
                  { to: '/sitemap' },
                  'Sitemap'
                )
              )
            )
          )
        ),
        !props.path.startsWith('/dashboard') && _react3.default.createElement(
          'div',
          { styleName: 'row-footer-2' },
          _react3.default.createElement(
            'div',
            { styleName: 'col-footer-list-2' },
            _react3.default.createElement(
              'h4',
              { styleName: 'footer-title' },
              'Top Destinations'
            ),
            _react3.default.createElement(
              'ul',
              { styleName: 'footer-list' },
              _react3.default.createElement(
                'li',
                null,
                _react3.default.createElement(
                  _Link2.default,
                  { to: '/to/Bangkok' },
                  'Bangkok'
                )
              ),
              _react3.default.createElement(
                'li',
                null,
                _react3.default.createElement(
                  _Link2.default,
                  { to: '/to/Ayutthaya' },
                  'Ayutthaya'
                )
              ),
              _react3.default.createElement(
                'li',
                null,
                _react3.default.createElement(
                  _Link2.default,
                  { to: '/to/Chiang Mai' },
                  'Chiang Mai'
                )
              ),
              _react3.default.createElement(
                'li',
                null,
                _react3.default.createElement(
                  _Link2.default,
                  { to: '/to/Hua Hin' },
                  'Hua Hin'
                )
              ),
              _react3.default.createElement(
                'li',
                null,
                _react3.default.createElement(
                  _Link2.default,
                  { to: '/to/Samut Prakan' },
                  'Samut Prakan'
                )
              )
            )
          ),
          _react3.default.createElement(
            'div',
            { styleName: 'col-footer-last-list-2' },
            _react3.default.createElement(
              'ul',
              { styleName: 'footer-list' },
              _react3.default.createElement(
                'li',
                null,
                _react3.default.createElement(
                  _Link2.default,
                  { to: '/to/Kanchanaburi' },
                  'Kanchanaburi'
                )
              ),
              _react3.default.createElement(
                'li',
                null,
                _react3.default.createElement(
                  _Link2.default,
                  { to: '/to/Pattaya' },
                  'Pattaya'
                )
              ),
              _react3.default.createElement(
                'li',
                null,
                _react3.default.createElement(
                  _Link2.default,
                  { to: '/to/Phuket' },
                  'Phuket'
                )
              ),
              _react3.default.createElement(
                'li',
                null,
                _react3.default.createElement(
                  _Link2.default,
                  { to: '/to/Samut Songkhram' },
                  'Samut Songkhram'
                )
              ),
              _react3.default.createElement(
                'li',
                null,
                _react3.default.createElement(
                  _Link2.default,
                  { to: '/other-cities' },
                  'Other Cities'
                )
              )
            )
          ),
          _react3.default.createElement(
            'div',
            { styleName: 'col-footer-list-2' },
            _react3.default.createElement(
              'h4',
              { styleName: 'footer-title' },
              'Top Activities'
            ),
            _react3.default.createElement(
              'ul',
              { styleName: 'footer-list' },
              _react3.default.createElement(
                'li',
                null,
                _react3.default.createElement(
                  _Link2.default,
                  { to: '/to/Bangkok/famous-attractions?focus=grand-palace-and-highlights' },
                  'City Tour'
                )
              ),
              _react3.default.createElement(
                'li',
                null,
                _react3.default.createElement(
                  _Link2.default,
                  { to: '/to/Bangkok/local-experiences?focus=best-nature-scenery' },
                  'Natural'
                )
              ),
              _react3.default.createElement(
                'li',
                null,
                _react3.default.createElement(
                  _Link2.default,
                  { to: '/to/Bangkok/famous-attractions?focus=khlong-lat-mayom' },
                  'Floating Market'
                )
              ),
              _react3.default.createElement(
                'li',
                null,
                _react3.default.createElement(
                  _Link2.default,
                  { to: '/to/Bangkok/local-experiences?focus=cooking-at-home' },
                  'Cooking Class'
                )
              )
            )
          ),
          _react3.default.createElement(
            'div',
            { styleName: 'col-footer-last-list-2' },
            _react3.default.createElement(
              'ul',
              { styleName: 'footer-list' },
              _react3.default.createElement(
                'li',
                null,
                _react3.default.createElement(
                  _Link2.default,
                  { to: '/to/Bangkok/local-experiences?focus=hua-hin-in-day' },
                  'Beach'
                )
              ),
              _react3.default.createElement(
                'li',
                null,
                _react3.default.createElement(
                  _Link2.default,
                  { to: '/to/Bangkok/local-experiences?focus=bike-tour-in-bangkok-s-green-lung' },
                  'Cycling'
                )
              ),
              _react3.default.createElement(
                'li',
                null,
                _react3.default.createElement(
                  _Link2.default,
                  { to: '/to/Bangkok/local-experiences?focus=canal-boat-tour' },
                  'Boating'
                )
              ),
              _react3.default.createElement(
                'li',
                null,
                _react3.default.createElement(
                  _Link2.default,
                  { to: '/to/Bangkok/local-experiences?focus=eat-local' },
                  'Street Food'
                )
              )
            )
          )
        ),
        _react3.default.createElement(
          'div',
          { styleName: 'copyright-row' },
          _react3.default.createElement(
            'h4',
            { styleName: 'copyright-text' },
            'Copyright \xA9 ',
            (0, _moment2.default)().format('YYYY'),
            ' TakeMeTour Pte. Ltd. All rights reserved.'
          )
        )
      )
    ),
    th: _react3.default.createElement(_Footer4.default, null),
    zh: _react3.default.createElement(_ZHFooter2.default, null)
  }[props.locale || 'en'];
};

var Footer = _wrapComponent('Footer')((_dec = (0, _reactCssModules2.default)(_Footer2.default), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Footer, _Component);

  function Footer() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Footer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Footer.__proto__ || (0, _getPrototypeOf2.default)(Footer)).call.apply(_ref, [this].concat(args))), _this), _this.state = { isShow: false }, _this.hasFooter = function () {
      // if (!this.props.path.startsWith('/to/') && !this.props.path.startsWith('/search') && !this.props.path.startsWith('/booking/') && !this.props.path.match(/^\/dashboard\/booking\/[0-9a-f]+$/)) {
      if (!_this.state.isShow) return false;
      var _this$props = _this.props,
          path = _this$props.path,
          userConfig = _this$props.userConfig;

      if (path && !path.startsWith('/booking/') && !path.startsWith('/pachantiew') && !path.match(/^\/dashboard\/booking\/[0-9a-f]+$/) && (!path.startsWith('/to/') || userConfig.searchPaginationEnabled)) {
        return true;
      }
      return false;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Footer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({ isShow: true }); // eslint-disable-line
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.hasFooter()) return _react3.default.createElement('div', null);
      return _react3.default.createElement(
        'div',
        { id: 'app-footer' },
        pickAndRenderFooter(this.props)
      );
    }
  }]);
  return Footer;
}(_react2.Component), _class2.propTypes = {
  user: _react2.PropTypes.object,
  locale: _react2.PropTypes.string,
  path: _react2.PropTypes.string,
  userConfig: _react2.PropTypes.object
}, _temp2)) || _class));

exports.default = Footer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Footer/Footer.js
// module id = 1672
// module chunks = 47